import { match } from 'ts-pattern';
import { _unsafeBuildDomainEntityId, parseDomainEntityId } from '@salsita-ai/platform-project-sdk/domain';
import { EuroCylinderHole as EuroCylinderHoleV1 } from '../__generated/model/versions/v1.js';
const toAuId = (id)=>_unsafeBuildDomainEntityId(`EuroCylinderHoleAu`, parseDomainEntityId(id).sequenceNumber);
const toEuId = (id)=>_unsafeBuildDomainEntityId(`EuroCylinderHoleEu`, parseDomainEntityId(id).sequenceNumber);
export const migrateToV2 = (state)=>{
    const auAnchorPointIds = new Set(state.filter((entity)=>EuroCylinderHoleV1.is(entity) && entity.isAustralian).map((entity)=>entity.id));
    return state.map((entity)=>{
        return match(entity).returnType().with({
            type: 'EuroCylinderHole'
        }, ({ id, isAustralian, ...euroCylinderHole })=>isAustralian ? {
                ...euroCylinderHole,
                id: toAuId(id),
                type: 'EuroCylinderHoleAu'
            } : {
                ...euroCylinderHole,
                id: toEuId(id),
                type: 'EuroCylinderHoleEu'
            }).with({
            type: 'AnchorPoint'
        }, (anchorPoint)=>{
            if (EuroCylinderHoleV1.isId(anchorPoint.shapeId)) {
                return {
                    ...anchorPoint,
                    shapeId: auAnchorPointIds.has(anchorPoint.shapeId) ? toAuId(anchorPoint.shapeId) : toEuId(anchorPoint.shapeId)
                };
            }
            return anchorPoint;
        }).otherwise((other)=>other);
    });
};

//# sourceMappingURL=v2.js.map